import { render, staticRenderFns } from "./SwitchOrdersReview.vue?vue&type=template&id=27ad5cfc&scoped=true"
import script from "./SwitchOrdersReview.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersReview.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersReview.vue?vue&type=style&index=0&id=27ad5cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad5cfc",
  null
  
)

export default component.exports